import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { GetPaymentServicesResponseType } from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseGetSelectedProductPaymentServicesInterface {
  getSelectedProductPaymentServicesApi: UseMutateAsyncFunction<
    GetPaymentServicesResponseType,
    unknown,
    {
      productCode: string;
    },
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetSelectedProductPaymentServices =
  (): UseGetSelectedProductPaymentServicesInterface => {
    const { paymentServices } = usePaymentServices();

    const getSelectedProductPaymentServices = ({
      productCode
    }: {
      productCode: string;
    }) => {
      return paymentServices.getPaymentGateways(productCode);
    };

    const { mutateAsync, error, status } = useMutation(
      getSelectedProductPaymentServices,
      {
        mutationKey: ['getSelectedProductPaymentServicesApi']
      }
    );

    return {
      getSelectedProductPaymentServicesApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetSelectedProductPaymentServices };
